var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_4634_266_00000067203988571670512230000005616771341329122947_);}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3,
    y: 4.1,
    width: 19.3,
    height: 17.3
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4.1,
    width: 19.3,
    height: 17.3,
    id: "mask0_4634_266_00000067203988571670512230000005616771341329122947_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.1,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.4,21.4l-0.7-0.7l6.2-6.2l3.5,3.5l5.2-5.2l0.7,0.7l-5.9,5.9l-3.5-3.5L7.4,21.4z M4.6,20.1 c-0.5,0-0.8-0.2-1.2-0.5C3.2,19.4,3,19,3,18.5V5.7c0-0.5,0.2-0.8,0.5-1.2c0.3-0.3,0.7-0.5,1.2-0.5h12.8c0.5,0,0.8,0.2,1.2,0.5 C18.8,4.9,19,5.3,19,5.7v4.2H4v8.6c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2V20.1z M4,8.9h14V5.7c0-0.2-0.1-0.3-0.2-0.4 c-0.1-0.1-0.3-0.2-0.4-0.2H4.6c-0.2,0-0.3,0.1-0.4,0.2C4.1,5.4,4,5.6,4,5.7V8.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.fd5b90310497b08612b708e3fbae691c.svg";
export { ForwardRef as ReactComponent };